import React from 'react';
import PropTypes from 'prop-types';
import PageContainer from '@deliveroo/consumer-component-library/components/PageContainer';
import P from '@deliveroo/consumer-component-library/components/P';
import Spacer from '@deliveroo/consumer-component-library/components/Spacer';
import Heading from '@deliveroo/consumer-component-library/components/Heading';

import Header from '../../containers/Header';
import LandingPageBreadcrumbs from '../LandingPageBreadcrumbs';
import styles from './CuisinePageHero.scss';

export default function CuisinePageHero({
  image,
  heading,
  description,
  locationSearch,
  breadcrumbs,
}) {
  return (
    <PageContainer fullWidth="always">
      <div className={styles.outerWrapper}>
        <Header isTransparent logoColor="white" />
        <div className={styles.image} style={{ backgroundImage: `url(${image})` }}>
          <PageContainer>
            <div className={styles.innerWrapper}>
              <LandingPageBreadcrumbs links={breadcrumbs} />
              <Heading level={1} size="medium" color="white" adjacentVerticalSpacing="medium">
                {heading}
              </Heading>
              <P color="white" adjacentVerticalSpacing="medium">
                {description}
              </P>
              <Spacer adjacentVerticalSpacing={{ mobile: 'medium', tablet: 'x-large' }}>
                {locationSearch}
              </Spacer>
            </div>
          </PageContainer>
        </div>
      </div>
    </PageContainer>
  );
}

CuisinePageHero.propTypes = {
  image: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  locationSearch: PropTypes.node.isRequired,
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
};
